if (!customElements.get('contact-form')) {
  customElements.define('contact-form', class ContactForm extends HTMLElement {
    constructor() {
      super();

      this.getValueFromURL('#ContactForm-name', 'contact[Name]=', '#ContactForm-name-error');
      this.getValueFromURL('#ContactForm-body', 'contact[Message]=', '#ContactForm-message-error');

      this.contactFormName = this.querySelector('#ContactForm-name');
      this.contactFormName.addEventListener('change', this.toggleErrorVisibilityOnInput.bind(this));
      this.contactFormName.addEventListener('blur', this.toggleErrorVisibilityOnInput.bind(this));
      
      this.contactFormEmail = this.querySelector('#ContactForm-email');
      this.contactFormEmail.addEventListener('change', this.toggleErrorVisibilityOnInput.bind(this));
      this.contactFormEmail.addEventListener('blur', this.toggleErrorVisibilityOnInput.bind(this));
      
      this.contactFormMessage = this.querySelector('#ContactForm-body');
      this.contactFormMessage.addEventListener('change', this.toggleErrorVisibilityOnInput.bind(this));
      this.contactFormMessage.addEventListener('blur', this.toggleErrorVisibilityOnInput.bind(this));
    }

    getValueFromURL (fieldName, fieldAttribute, errorParentElementName) {
      var decodedUri = decodeURI(window.location.search);
      if (decodedUri) {
        const fieldValue = decodedUri.split(`${fieldAttribute}`)[1].split('&')[0];
        this.querySelector(`${fieldName}`).value = fieldValue.replaceAll('+', ' ');
        if (!fieldValue) {
          this.querySelector(`${errorParentElementName}`).classList.remove('visually-hidden');
        } else {
          this.querySelector(`${errorParentElementName}`).classList.add('visually-hidden');
        } 
      }
    }

    toggleErrorVisibilityOnInput(event) {
      this.isEmailValid = (event.target.type === 'email') ? this.validateEmailField(event) : '';
      if (!event.target.value || (event.target.type === 'email' && this.isEmailValid == false)) {
        event.target.parentElement.children[2].classList.remove('visually-hidden');
      } else if (event.target.value) {
        event.target.parentElement.children[2].classList.add('visually-hidden');
      }
      this.disableSubmitButton(this.contactFormName, this.contactFormEmail, this.contactFormMessage);
    }

    disableSubmitButton (name, email, message) {
      this.contactFormSubmitBtn = this.querySelector('.contact__button button')
      if (!name.value || !email.value || !message.value) {
        this.contactFormSubmitBtn.setAttribute('disabled', 'disabled');
      } else {
        this.contactFormSubmitBtn.removeAttribute('disabled', 'disabled');
      }
    }

    validateEmailField (event) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value);
    }
  });
}
